import { Dataset } from '../../types/types';

export const getDetailFilterObject = (dataset: Dataset, rowId: string) => {
  return {
    [dataset.idItem]: {
      equals: rowId,
    },
  };
};
